import React from 'react';
import Icon from '../atoms/Icon';

function SocialFacebookIcon(props: any, ref: React.Ref<any>) {
  return (
    <Icon {...props} ref={ref}>
      <path d="M3.55556 0C1.59467 0 0 1.59467 0 3.55556V28.4444C0 30.4053 1.59467 32 3.55556 32H15.3264H20.2917H28.4444C30.4053 32 32 30.4053 32 28.4444V3.55556C32 1.59467 30.4053 0 28.4444 0H3.55556ZM3.55556 3.55556H28.4444L28.4479 28.4444H20.2917V21.3958H24.4965L25.1215 16.5521H20.3194V13.4653C20.3194 12.0644 20.7099 11.1181 22.7188 11.1181H25.2569V6.79514C24.0214 6.66892 22.7809 6.60756 21.5382 6.61111C17.8511 6.61111 15.3264 8.8615 15.3264 12.9931V16.559H11.1597V21.4028H15.3264V28.4444H3.55556V3.55556Z" fill="currentColor"/>
    </Icon>
  );
}

export default React.forwardRef(SocialFacebookIcon);